import * as React from "react";

export const GFLLandingPage: React.FC = () => {
    window.location.href = "/1/index.html";
    return null;
};